import Image from 'next/image';
import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 100%;
`;

export const ImageWrapper = styled.div`
  & > img {
    border-radius: 8px;
  }

  & > div {
    position: absolute !important;
    height: 100%;
  }
`;

export const StyledImage = styled(Image)`
  z-index: -1;
  object-fit: cover;
`;

export const TopInfo = styled.div`
  position: absolute;
  display: flex;
  top: 16px;
  left: 16px;
  width: 100%;
  z-index: 1;
`;

export const TopInfoText = styled.span`
  font-weight: 600;
  font-size: 80px;
  line-height: 60px;
  color: ${({ theme }) => theme.palette.white};
`;
export const BottomInfoContainer = styled.div`
  border-radius: 8px;
  position: absolute;
  height: 100%;
  width: 100%;
  bottom: 0px;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.08) 50%,
    rgba(0, 0, 0, 0.4) 100%
  );
`;

export const BottomInfo = styled.div`
  position: absolute;
  bottom: 20px;
  width: 100%;
  padding: 0 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    padding-left: 8px;
  }
`;

export const Title = styled.h3`
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: ${({ theme }) => `${theme.palette.white}`};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.WIDE_DESKTOP})`} {
    font-size: 24px;
  }
`;

export const TextWrapper = styled.span`
  line-height: 30px;
  color: ${({ theme }) => theme.palette.white};
  display: flex;
  align-items: flex-end;
  font-size: 24px;
  font-weight: 700;
`;

export const RedDivider = styled.div<{
  height?: number;
  width?: number;
}>`
  width: ${({ width = 6 }) => `${width}px`};
  margin-right: 10px;
  height: ${({ height = 36 }) => `${height}px`};
  border-radius: 5px;
  background-color: ${({ theme }) => `${theme.palette.coral}`};
  margin-top: 5px;
`;
